import { render, staticRenderFns } from "./PhotoWidget.vue?vue&type=template&id=fe215682&scoped=true&"
import script from "./PhotoWidget.vue?vue&type=script&lang=js&"
export * from "./PhotoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe215682",
  null
  
)

export default component.exports